import Enquiry from './Enquiry'

export default Enquiry